<div class="login-layout-main-text">
    <div [hidden]="!loginStyleLoaded" class="login-layout-main-text-ctr">
        <div *ngIf="clientMainHTML">
            <div [innerHTML]="clientMainHTML | trustHtml"></div>
        </div>

        <div *ngIf="!clientMainHTML && hasCurrentCase">
            <div class="login-layout-main-text-hdr" style="font-size: 175%; margin-bottom: 20px;">
                Initial Account Login &amp; Set-up Steps
            </div>
            <ul class="login-layout-main-text-items">
                <li>
                    You are required to complete a one-time registration verification to establish secure login credentials
                    by selecting the &#8220;Create New Account&#8221; button to the left and follow the registration steps.
                </li>
                <li>
                    You will be asked to enter information that will be used to verify your identity.
                </li>
                <li>
                    You will be prompted to enter your email address (which will be your username) and create a unique password.
                </li>
                <li>
                    You must request and enter the verification code that is sent to your email address or phone number in order to activate your account.
                </li>
                <li>
                    Once you have an account created, you will enter your email address and password and then select &#8220;Login&#8221; to access your benefits portal.
                </li>
            </ul>
        </div>

        <div *ngIf="!clientMainHTML && !hasCurrentCase">
            <div class="login-layout-main-text-hdr" style="font-size: 175%; margin-bottom: 20px;">
                Learn. Enroll. Manage.
            </div>
            <div class="login-layout-main-text-p" style="margin-bottom: 20px;">
                Use this site as an online resource for
                all your benefit related needs. Here you can:
            </div>
            <ul class="login-layout-main-text-items">
                <li>Learn about available plans</li>
                <li>Enroll in new plan elections</li>
                <li>Manage all your plans throughout the year</li>
            </ul>
        </div>
    </div>
</div>
